<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">广播列表</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="deviceName">
            <el-input
              v-model="deviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EqRegionArr"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onSynch">同步广播设备</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="DeviceNum" label="设备编号">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).DeviceNum
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="IP" label="设备IP地址">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).IP
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="RegionId"
                label="区域"
                :formatter="RegionNumToNameConverter"
              ></el-table-column>
              <el-table-column prop="Longitude" label="经度"></el-table-column>
              <el-table-column prop="Latitude" label="纬度"></el-table-column>
              <el-table-column prop="IsOnline" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color:red;"
                    >离线</span
                  >
                  <span
                    v-else-if="scope.row.IsOnline == true"
                    style="color:green;"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import utils from "../../../../../../utils";
import ZJApp from "../../../../../app";

export default {
  name: "DeviceManagerHttpView",
  controller: "UI",
  action: "DeviceManagerHttpView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deviceName: null,
      RegionId: null,
      EqRegionArr: [],
      loading: false,
      loadingText: "",
      endpoints: [],
    };
  },
  created: function() {
    //所属区域
    this.getRegionInfo();
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "广播列表查询";
    this.logInfo.LogMessage = "广播列表查询";
    this.logInfo.ModuleName = "广播系统";
    this.logInfo.PageName = "广播列表";
    // this.addOperationLog();
  },
  methods: {
    RegionNumToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const RegionName = this.EqRegionArr.map((item) => {
        if (item.RegionId == data) return item.RegionName;
      }).join("");
      if (RegionName == null || RegionName == "") {
        return data;
      }
      return RegionName;
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let searchInfo = {
        DeviceName: this.deviceName == "" ? null : this.deviceName,
        RegionId: this.RegionId == "" ? null : this.RegionId,
        EquipmentType: "Broadcast",
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/broadcast/UI/DeviceManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/DeviceManagerInfo",
        query: { InfoId: row.DeviceId, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/DeviceManagerInfo",
        query: { InfoId: row.DeviceId, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //同步广播设备
    onSynch() {
      this.loading = true;
      this.loadingText = "查询设备数据库...";
      let that = this;
    
      that.handleLoad();
    },
    SynchData() {
      let that = this;
      utils
        .waitAll([() => this.getRegions(), () => this.getEquipments()])
        .then((r) => {
          let regionArr = r[0].data.Data;
          let regionMap = {};
          //根据regionid索引区域
          regionArr.forEach((element) => {
            regionMap[element.RegionId] = element;
          });
          //无相同名称的区域时，使用此区域作为新同步设备的区域
          let defRegion = regionArr
            .filter((item) => {
              return item.RegionName == "其他" || item.RegionName == "其它";
            })
            .slice(0, 1);
          if (defRegion.length == 0) {
            defRegion = regionArr.slice(0, 1);
          }

          let deviceArr = r[1].data.Data;
          let deviceMap = {};
          //根据deviceid索引设备
          deviceArr.forEach((element) => {
            deviceMap[element.DeviceId] = element;
          });

          console.log(that.endpoints);
          let dev = {
            JsonExtend: {
              DeviceNum: null,
              ShortName: null,
              IP: null,
              WarrantyPeriod: null,
              Remark: null,
              Address: null,
            },
          };
          let exists = {};
          let totalNum = 0;
          let added = 0;
          let updated = 0;
          let deleted = 0;
          that.endpoints.forEach((item) => {
            if (deviceMap[item.EndpointID]) {
              dev = {
                JsonExtend: {
                  DeviceNum: null,
                  ShortName: null,
                  IP: null,
                  WarrantyPeriod: null,
                  Remark: null,
                  Address: null,
                },
              };
              that.Copy(dev, item);

              if (dev.RegionId == "" || dev.RegionId == undefined) {
                dev.RegionId = defRegion[0].RegionId;
                dev.RegionName = defRegion[0].RegionName;
              }
              dev.JsonExtend = JSON.stringify(dev.JsonExtend);
              dev.EquipmentType = "Broadcast";
              dev.Modifier = ZJApp.ZJUser.current.UserName;
              dev.ModifyTime = new Date();
              that.UpdateEquipment(dev);
              updated = updated + 1;
            } else {
              dev = {
                JsonExtend: {
                  DeviceNum: null,
                  ShortName: null,
                  IP: null,
                  WarrantyPeriod: null,
                  Remark: null,
                  Address: null,
                },
              };
              // dev.JsonExtend = JSON.parse(dev.JsonExtend);
              that.Copy(dev, item);
              if (dev.RegionId == "" || dev.RegionId == undefined) {
                dev.RegionId = defRegion[0].RegionId;
                dev.RegionName = defRegion[0].RegionName;
              }
              dev.JsonExtend = JSON.stringify(dev.JsonExtend);
              dev.EquipmentType = "Broadcast";
              dev.Modifier = ZJApp.ZJUser.current.UserName;
              dev.ModifyTime = new Date();
              dev.Creater = ZJApp.ZJUser.current.UserName;
              dev.CreateTime = new Date();
              dev.Validity = 1;
              that.AddEquipment(dev);
              added = added + 1;
            }
            exists[dev.DeviceId] = true;
            totalNum = totalNum + 1;
            //更新进度百分比
            let percent = (100 * totalNum) / that.endpoints.length;
            that.loadingText = `同步设备信息... ${percent}%"`;
          });
          if (totalNum > 0) {
            deviceArr.forEach((item) => {
              if (!exists[item.DeviceId]) {
                item.Modifier = ZJApp.ZJUser.current.UserName;
                item.ModifyTime = new Date();
                item.Validity = 0;
                that.DelEquipment(item);
                deleted = deleted + 1;
              }
            });
          }
          that.loading = false;
          if (added > 0 || updated > 0 || deleted > 0) {
            setTimeout(() => {
              that.search();
            },1000);
          }

          this.$message({
            type: "info",
            message: `"同步成功，新增 ${added} 个，更新 ${updated} 个，移除 ${deleted} 个，共 ${totalNum} 个设备。"`,
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //获取设备列表
    getEquipments() {
      return new MyApis.TranResourcesApi().GetEquipmentMangeList({
        EquipmentType: "Broadcast",
      });
    },
    //获取区域列表
    getRegions() {
      return new MyApis.RegionList().GetRegionInfos({
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      });
    },
    // 加载设备
    handleLoad() {
      this.endpoints = [];
      this.loading = true;
      this.loadingText = "加载广播设备中...";
      new MyApis.BrocastHttpApi()
        .GetSerTerminals()
        .then((r) => {
          this.onGetEndpoints(r.data.Data);
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },


    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error("出错了: " + msg);
      this.loading = false;
    },
   

    // 处理获取设备的响应
    onGetEndpoints(r) {
      if (r.length>0) {
        const list = r;
        console.log(list);
        for (let i = 0; i < list.length; i++) {
          this.endpoints.push(list[i]);
        }

        if (this.endpoints.length >= list.length) {
          this.loadingText = "加载广播设备...100%";
        }
        this.SynchData();
      } else {
        this.loading = false;
        console.error(r && r.msg ? r.msg : "未获取到设备信息");
        this.$message.error(r && r.msg ? r.msg : "出错了: 无设备信息");
      }
    },
    Copy(dest, src) {
      dest.DeviceId = src.EndpointID;
      dest.DeviceName = src.EndpointName;
      dest.IsOnline = src.Status == "1";
      // dest.JsonExtend = JSON.parse(dest.JsonExtend);
      dest.JsonExtend.IP = src.EndpointIP;
      dest.JsonExtend.MacAddr = "";
      dest.JsonExtend.Volume = src.Volume;
      dest.JsonExtend.Type = src.EndpointType;
      dest.JsonExtend.Version = src.EndpointTypeName;
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.deviceName = null;
      this.RegionId = null;
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    UpdateEquipment(dev) {
      new MyApis.TranResourcesApi()
        .UpdateEquipment(dev)
        .then((r) => {
          r = r.data.Data;
          if (r) console.log("修改成功");
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    AddEquipment(dev) {
      new MyApis.TranResourcesApi()
        .AddEquipment(dev)
        .then((r) => {
          r = r.data.Data;
          if (r) console.log("添加成功");
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    DelEquipment(dev) {
      new MyApis.TranResourcesApi()
        .DelEquipment(dev)
        .then((r) => {
          r = r.data.Data;
          if (r) console.log("删除成功");
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    }
  },
};
</script>
